import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const BreakdownByBucket = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${arg.argumentText}</div>
          <div>${arg.valueText} €</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Breakdown by Bucket"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          id="bucketChart"
          ref={chartRef}
          palette={palette}
        >
          <Series valueField="value" argumentField="name" type="bar" />
          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>
          <ValueAxis />
          <Legend visible={false} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default BreakdownByBucket;
